/* eslint-disable */
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

const FAQBlock = ({ title, items }: { title?: string, items?: any[] }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    if (!items || items.length === 0) return null;
    const { t } = useTranslation();
    return (
        <div className="faq-block">
            <div className="faq-title">{title || t('subscription.faqTitle')}</div>
            <div className="faq-list">
                {items.map((item, idx) => (
                    <div key={item.id || idx}>
                        <div
                            className="faq-item"
                            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                            style={{ cursor: 'pointer', fontWeight: 600 }}
                        >
                            <span className="faq-question">{item.question}</span>
                            <span className={`faq-arrow${openIndex === idx ? ' faq-arrow--open' : ''}`}>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M6 8l4 4 4-4" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </span>
                        </div>
                        {openIndex === idx && (
                            <div className="faq-answer">{item.answer}</div>
                        )}
                        <div className="faq-divider" />
                    </div>
                ))}
            </div>
        </div>
    );
};


export default FAQBlock;
